var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 24,
    viewBox: "0 0 17 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.32011 0.449219C3.81854 0.449219 0.177734 4.07086 0.177734 8.54874C0.177734 14.6234 8.32011 23.5907 8.32011 23.5907C8.32011 23.5907 16.4625 14.6234 16.4625 8.54874C16.4625 4.07086 12.8217 0.449219 8.32011 0.449219ZM8.32011 11.4414C6.7149 11.4414 5.41212 10.1455 5.41212 8.54874C5.41212 6.95198 6.7149 5.65605 8.32011 5.65605C9.92532 5.65605 11.2281 6.95198 11.2281 8.54874C11.2281 10.1455 9.92532 11.4414 8.32011 11.4414Z",
    fill: "#3290EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoint);
export default __webpack_public_path__ + "static/media/point.21cbdf0e114e0a671633c9ba5952969c.svg";
export { ForwardRef as ReactComponent };